import { Icon } from "@nabble/ui";

/** Footer link back to the list of methods. */
export function ChooseAnotherMethod({ onClick }: { onClick: () => void }): React.JSX.Element {
  return (
    <div className="nb-auth-foot">
      <button type="button" className="nb-link-btn nb-auth-back" onClick={onClick}>
        <Icon name="arrowLeft" />
        Choose another method
      </button>
    </div>
  );
}
